(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-product-highlight';
  var TAB_SELECTOR = '.oddit-section-product-highlight__tab';
  var CARD_SELECTOR = '.oddit-section-product-highlight__card';
  var ACTIVE_TAB_CLASS = 'oddit-section-product-highlight__tab--active';
  var ACTIVE_CARD_CLASS = 'oddit-section-product-highlight__card--active';

  function activateTab(section, index) {
    var tabs = section.querySelectorAll(TAB_SELECTOR);
    var cards = section.querySelectorAll(CARD_SELECTOR);

    tabs.forEach(function (tab) {
      var tabIndex = Number(tab.getAttribute('data-tab-index'));
      var isActive = tabIndex === index;
      tab.classList.toggle(ACTIVE_TAB_CLASS, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    cards.forEach(function (card) {
      var cardIndex = Number(card.getAttribute('data-card-index'));
      card.classList.toggle(ACTIVE_CARD_CLASS, cardIndex === index);
    });
  }

  function initSection(section) {
    var tabs = section.querySelectorAll(TAB_SELECTOR);
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var index = Number(tab.getAttribute('data-tab-index'));
        if (Number.isNaN(index)) return;
        activateTab(section, index);
      });

      tab.addEventListener('keydown', function (e) {
        var currentIndex = Number(tab.getAttribute('data-tab-index'));
        var nextIndex = currentIndex;
        if (e.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else {
          return;
        }
        e.preventDefault();
        activateTab(section, nextIndex);
        tabs[nextIndex].focus();
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();